import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbTypeaheadModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule as PlatformSharedModule } from '@dx/platform-components';

import { GoToInputComponent } from './go-to-input.component';

@NgModule({
  declarations: [GoToInputComponent],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    FontAwesomeModule,
    NgbTypeaheadModule,
    NgbDropdownModule,
    PlatformSharedModule
  ],
  exports: [GoToInputComponent]
})
export class GoToInputModule { }
